import styled from 'styled-components';

export const Container2 = styled.div`
  width: 100%;
  max-width: 645px;
  display: flex;
  flex-direction: column;
  margin: 35vh auto;
`;

export const Container1 = styled.div`
  width: 100%;
  max-width: 645px;
  display: flex;
  margin: 15vh auto;
  align-items: center;
  justify-content: center;
  flex-direction:column;
`;
